module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contain-box"
  }, [(_vm.dialogAdd) ? _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.asset_loading),
      expression: "asset_loading"
    }],
    staticClass: "contain-box add_box"
  }, [_c('el-tabs', {
    ref: "tabs",
    staticStyle: {
      "padding": "0px 8px 8px 8px"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "主要信息",
      "name": "first"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon label-svg",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconzhuyaozhineng"
    }
  })]), _vm._v("\n                主要信息\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-body",
    style: (_vm.box_style)
  }, [_c('el-form', {
    ref: "asset_main_information",
    attrs: {
      "label-width": "110px",
      "size": "mini",
      "label-position": _vm.labelPosition,
      "model": _vm.asset_main_information,
      "rules": _vm.rules_main_text
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "8px 8px 8px 0px"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "资源名称",
      "prop": "server_busi_name"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconxingzhuang"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("资源名称")])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.asset_main_information.server_busi_name),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "server_busi_name", $$v)
      },
      expression: "asset_main_information.server_busi_name"
    }
  })], 1), _vm._v(" "), (_vm.assets_add_edit) ? _c('el-form-item', {
    attrs: {
      "label": "IP",
      "prop": "server_ip"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconIP5"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("IP")])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入ip,若主机已经存在可以点击获取按钮获取信息"
    },
    model: {
      value: (_vm.asset_main_information.server_ip),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "server_ip", $$v)
      },
      expression: "asset_main_information.server_ip"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "系统平台",
      "prop": "server_os"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconlinux"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("系统平台")])]), _vm._v(" "), _c('sys_code_select', {
    attrs: {
      "sys_code_type": "server_os_type",
      "sys_code_has_all": false,
      "sys_code_style": {
        "width": "90%"
      },
      "default_value": _vm.asset_main_information.server_os
    },
    on: {
      "sys_code_change": _vm.server_os_change
    },
    model: {
      value: (_vm.asset_main_information.server_os),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "server_os", $$v)
      },
      expression: "asset_main_information.server_os"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "prop": "server_os_version"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入系统版本"
    },
    model: {
      value: (_vm.asset_main_information.server_os_version),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "server_os_version", $$v)
      },
      expression: "asset_main_information.server_os_version"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.assets_add_edit) ? _c('el-form-item', {
    attrs: {
      "label": "资源名称",
      "prop": "server_name"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconOSzhujimingcheng"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("资源名称")])]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.asset_main_information.server_name),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "server_name", $$v)
      },
      expression: "asset_main_information.server_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "资源类型",
      "prop": "server_virtualization_type"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconOSzhujimingcheng"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("资源类型")])]), _vm._v(" "), _c('sys_code_select', {
    attrs: {
      "sys_code_has_all": false,
      "sys_code_type": "server_virtualization_type",
      "default_value": _vm.asset_main_information.server_virtualization_type
    },
    model: {
      value: (_vm.asset_main_information.server_virtualization_type),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "server_virtualization_type", $$v)
      },
      expression: "asset_main_information.server_virtualization_type"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CPU频率",
      "prop": "cpu_frequency"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconcpu"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("CPU频率")])]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.asset_main_information.cpu_frequency),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "cpu_frequency", $$v)
      },
      expression: "asset_main_information.cpu_frequency"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CPU核数",
      "prop": "cpu_cores"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconcpu"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("CPU核数")])]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.asset_main_information.cpu_cores),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "cpu_cores", $$v)
      },
      expression: "asset_main_information.cpu_cores"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "硬盘容量GB",
      "prop": "disk_total_size"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconcipan"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("硬盘容量GB")])]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.asset_main_information.disk_total_size),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "disk_total_size", $$v)
      },
      expression: "asset_main_information.disk_total_size"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "memory_size"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconmemavg"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("内存GB")])]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.asset_main_information.memory_size),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "memory_size", $$v)
      },
      expression: "asset_main_information.memory_size"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "激活",
      "prop": "is_actived"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconjihuo"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("激活")])]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.asset_main_information.is_actived),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "is_actived", $$v)
      },
      expression: "asset_main_information.is_actived"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "8px"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物理位置",
      "prop": "location"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconwuliweizhi"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("物理位置")])]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.asset_main_information.location),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "location", $$v)
      },
      expression: "asset_main_information.location"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "端口",
      "prop": "server_port"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconduankou2"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("端口")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.asset_main_information.server_port),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "server_port", $$v)
      },
      expression: "asset_main_information.server_port"
    }
  }), _vm._v(" "), (_vm.seach_or_edit) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.get_hardware_button
    }
  }, [_vm._v("获取")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "协议",
      "prop": "connect_protocol_type_code"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconxieyi"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("协议")])]), _vm._v(" "), _c('sys_code_select', {
    attrs: {
      "sys_code_has_all": false,
      "sys_code_type": "connect_protocol_type",
      "default_value": _vm.asset_main_information.connect_protocol_type_code
    },
    model: {
      value: (_vm.asset_main_information.connect_protocol_type_code),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "connect_protocol_type_code", $$v)
      },
      expression: "asset_main_information.connect_protocol_type_code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公网地址",
      "prop": "internet_address"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_icongongwangIP"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("公网地址")])]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.asset_main_information.internet_address),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "internet_address", $$v)
      },
      expression: "asset_main_information.internet_address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CPU颗数",
      "prop": "cpu_physical_count"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconcpu"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("CPU颗数")])]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.asset_main_information.cpu_physical_count),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "cpu_physical_count", $$v)
      },
      expression: "asset_main_information.cpu_physical_count"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CPU缓存KB",
      "prop": "cpu_cache"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconcpu"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("CPU缓存KB")])]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.asset_main_information.cpu_cache),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "cpu_cache", $$v)
      },
      expression: "asset_main_information.cpu_cache"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "磁盘数量",
      "prop": "disk_count"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconcipan"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("磁盘数量")])]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.asset_main_information.disk_count),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "disk_count", $$v)
      },
      expression: "asset_main_information.disk_count"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "逻辑核",
      "prop": "cpu_logic_count"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon ",
    staticStyle: {
      "width": "1em",
      "height": "1em",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconluojihechashezhi"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("逻辑核")])]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.asset_main_information.cpu_logic_count),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "cpu_logic_count", $$v)
      },
      expression: "asset_main_information.cpu_logic_count"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-divider', {
    staticStyle: {
      "margin": "10px 0px",
      "width": "99%"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "asset_other_information",
    staticStyle: {
      "padding": "8px"
    },
    attrs: {
      "model": _vm.asset_other_information,
      "label-width": "120px",
      "size": "mini",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "系统日志路径",
      "prop": "os_log_path"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.asset_other_information.os_log_path),
      callback: function($$v) {
        _vm.$set(_vm.asset_other_information, "os_log_path", $$v)
      },
      expression: "asset_other_information.os_log_path"
    }
  })], 1), _vm._v(" "), (_vm.assets_add_edit) ? _c('el-form-item', {
    attrs: {
      "label": "标签",
      "prop": "label_ids"
    }
  }, [_c('label_sys_select', {
    attrs: {
      "label_group_search": "asset_type_03",
      "sys_code_has_all": false,
      "sys_code_multiple": true,
      "default_value": _vm.asset_other_information.label_ids,
      "allow_create": true
    },
    on: {
      "sys_code_change": _vm.label_change
    },
    model: {
      value: (_vm.asset_other_information.label_ids),
      callback: function($$v) {
        _vm.$set(_vm.asset_other_information, "label_ids", $$v)
      },
      expression: "asset_other_information.label_ids"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "other_comments"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.asset_other_information.other_comments),
      callback: function($$v) {
        _vm.$set(_vm.asset_other_information, "other_comments", $$v)
      },
      expression: "asset_other_information.other_comments"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "拓补信息"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon",
    staticStyle: {
      "width": "1.3em",
      "height": "1.3em",
      "top": "2px",
      "color": "#666"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_icontopology"
    }
  })]), _vm._v("\n                拓补信息\n              ")]), _vm._v(" "), _c('el-form', {
    ref: "asset_topology_information",
    staticClass: "form-body",
    style: (_vm.box_style),
    attrs: {
      "label-width": "120px",
      "size": "mini",
      "label-position": _vm.labelPosition,
      "model": _vm.asset_topology_information
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "区域",
      "rules": {
        required: true,
        message: '区域不能为空',
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.area_path),
      callback: function($$v) {
        _vm.area_path = $$v
      },
      expression: "area_path"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Vmware宿主机",
      "prop": "host_machine_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.vmware_change
    },
    model: {
      value: (_vm.asset_topology_information.host_machine_id),
      callback: function($$v) {
        _vm.$set(_vm.asset_topology_information, "host_machine_id", $$v)
      },
      expression: "asset_topology_information.host_machine_id"
    }
  }, _vm._l((_vm.host_machine_data), function(item) {
    return _c('el-option', {
      key: item.server_id,
      attrs: {
        "label": item.server_ip,
        "value": item.server_id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "margin": "4px 25px",
      "color": "#BCBCBC"
    }
  }, [_vm._v("非vmware虚拟化主机无需填写此项")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "父节点",
      "prop": "father_node"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.asset_topology_information.father_node),
      callback: function($$v) {
        _vm.$set(_vm.asset_topology_information, "father_node", $$v)
      },
      expression: "asset_topology_information.father_node"
    }
  }, _vm._l((_vm.assets_add_data), function(item) {
    return _c('el-option', {
      key: item.server_id,
      attrs: {
        "label": item.server_ip,
        "value": item.server_id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "margin": "4px 25px",
      "color": "#BCBCBC"
    }
  }, [_vm._v("父节点描述其上游的基础设施，比如所属宿主机，网络连接交换机等")]), _c('br')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "子节点",
      "prop": "child_node"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.asset_topology_information.child_node),
      callback: function($$v) {
        _vm.$set(_vm.asset_topology_information, "child_node", $$v)
      },
      expression: "asset_topology_information.child_node"
    }
  }, _vm._l((_vm.assets_add_data), function(item) {
    return _c('el-option', {
      key: item.server_id,
      attrs: {
        "label": item.server_ip,
        "value": item.server_id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "margin": "4px 25px",
      "color": "#BCBCBC"
    }
  }, [_vm._v("子节点描述其下游基础设置，与父节点对应")]), _c('br')], 1)], 1)], 1), _vm._v(" "), (_vm.assets_add_edit) ? _c('el-tab-pane', {
    attrs: {
      "label": "用户信息",
      "name": "user"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon",
    staticStyle: {
      "width": "1.3em",
      "height": "1.3em",
      "top": "2px",
      "color": "#666"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconyonghu7"
    }
  })]), _vm._v("\n                用户信息\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-body",
    style: (_vm.box_style)
  }, [(_vm.seach_or_edit) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.add_user_button
    }
  }, [_vm._v("绑定系统用户")]) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "data": _vm.asset_user_information,
      "height": "calc(100% - 30px)"
    },
    on: {
      "row-click": _vm.getDetails
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "default_user",
      "width": "80px",
      "label": "默认用户"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(server_name) {
        return [(server_name.row.default_user === true) ? _c('i', {
          staticClass: "el-icon-s-custom",
          staticStyle: {
            "color": "#13CE66",
            "font-size": "18px"
          },
          attrs: {
            "title": "默认用户"
          }
        }) : _c('i')]
      }
    }], null, false, 1982148961)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_name",
      "label": "用户名",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ossoft_user_group_id",
      "label": "用户类型",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_home",
      "width": "180px",
      "label": "用户主目录"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "comments",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addresss",
      "width": "200",
      "label": "动作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_user) {
        return [(_vm.seach_or_edit) ? _c('el-button', {
          attrs: {
            "type": "warning",
            "circle": "",
            "icon": "el-icon-omnis-mima",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.edit_user_password_button(scope_user.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.seach_or_edit) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "circle": "",
            "icon": "el-icon-edit",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.edit_user_button(scope_user.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.seach_or_edit) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "circle": "",
            "icon": "el-icon-delete",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.delete_user_button(scope_user.row)
            }
          }
        }) : _vm._e()]
      }
    }], null, false, 3154841266)
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.assets_add_edit) ? _c('el-tab-pane', {
    attrs: {
      "label": "变更信息"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('svg', {
    staticClass: "icon",
    staticStyle: {
      "width": "1.3em",
      "height": "1.3em",
      "top": "2px",
      "color": "#666"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconicon_zichanguanbiangengshenqing"
    }
  })]), _vm._v("\n                变更信息\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-body",
    style: (_vm.box_style)
  }, [_c('div', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "align": "left"
    }
  }, [_c('omnis_button', {
    attrs: {
      "href": "#the_third_iconyishanchu2-copy-copy",
      "button_name": "已删除资源"
    },
    on: {
      "handle_click": _vm.open_delete_diglog
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "data": _vm.asset_change_information,
      "height": "calc(100% - 30px)"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "时间",
      "prop": "operator_time",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nick",
      "label": "操作人",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "modify_recoder_type_name",
      "width": "100",
      "label": "类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "modify_property",
      "label": "修改属性"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "modify_before",
      "label": "修改前"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "modify_after",
      "label": "修改后"
    }
  })], 1)], 1)]) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticClass: "box-footer"
  }, [(_vm.edit_information_div) ? _c('div', {
    staticStyle: {
      "background": "#F0F8FA",
      "text-align": "left",
      "margin-bottom": "4px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "13px",
      "margin": "4px 10px"
    }
  }, [_vm._v(" 资源新增时间")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "40px",
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.asset_add_time))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px",
      "margin": "4px 10px"
    }
  }, [_vm._v("资源最后修改时间")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "40px",
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.asset_edit_time))])]) : _vm._e(), _vm._v(" "), (_vm.seach_or_edit) ? _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handle_close
    }
  }, [_vm._v("关 闭")]) : _vm._e(), _vm._v(" "), (_vm.seach_or_edit) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.asset_addall_button('asset_main_information')
      }
    }
  }, [_vm._v("确 定")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "append-to-body": "",
      "title": "主机删除日志",
      "visible": _vm.delete_info_dialog,
      "width": "50",
      "close-on-click-modal": false,
      "top": "8vh"
    },
    on: {
      "update:visible": function($event) {
        _vm.delete_info_dialog = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.server_del_form,
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "IP"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "资源IP"
    },
    model: {
      value: (_vm.server_del_form.server_ip),
      callback: function($$v) {
        _vm.$set(_vm.server_del_form, "server_ip", $$v)
      },
      expression: "server_del_form.server_ip"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "操作人"
    }
  }, [_c('user_select', {
    attrs: {
      "user_options": _vm.user_data
    },
    model: {
      value: (_vm.server_del_form.operator_user),
      callback: function($$v) {
        _vm.$set(_vm.server_del_form, "operator_user", $$v)
      },
      expression: "server_del_form.operator_user"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.get_server_delete_getData
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.ser_del_loading),
      expression: "ser_del_loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "data": _vm.server_delete_data,
      "height": _vm.server_del_height
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "server_name",
      "width": "180",
      "label": "资源"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "server_ip",
      "label": "IP"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nick",
      "label": "操作人",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时间",
      "prop": "operator_time",
      "width": "150"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": 10,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.del_count
    },
    on: {
      "size-change": _vm.server_delSizeChange,
      "current-change": _vm.server_delCurrentChange
    }
  })], 1), _vm._v(" "), (_vm.dialogAdd_edit) ? _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.asset_loading),
      expression: "asset_loading"
    }],
    staticClass: "contain-box batch_add_box"
  }, [_c('el-tabs', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tab_loading),
      expression: "tab_loading"
    }],
    ref: "tabs",
    staticStyle: {
      "padding": "0px 8px 8px 8px"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "主要信息",
      "name": "first"
    }
  }, [_c('div', {
    staticClass: "form-body",
    style: (_vm.box_style)
  }, [_c('el-form', {
    ref: "asset_main_information_batch",
    attrs: {
      "label-width": "110px",
      "size": "mini",
      "label-position": _vm.labelPosition,
      "model": _vm.asset_main_information,
      "rules": _vm.rules_main_text2
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "8px 8px 8px 0px"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物理位置",
      "prop": "location"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.asset_main_information.location),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "location", $$v)
      },
      expression: "asset_main_information.location"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "系统平台",
      "prop": "server_os"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('sys_code_select', {
    attrs: {
      "sys_code_type": "server_os_type",
      "sys_code_has_all": false,
      "sys_code_style": {
        "width": "90%"
      },
      "default_value": _vm.asset_main_information.server_os
    },
    model: {
      value: (_vm.asset_main_information.server_os),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "server_os", $$v)
      },
      expression: "asset_main_information.server_os"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入系统版本"
    },
    model: {
      value: (_vm.asset_main_information.server_os_version),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "server_os_version", $$v)
      },
      expression: "asset_main_information.server_os_version"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "端口",
      "prop": "server_port"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.asset_main_information.server_port),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "server_port", $$v)
      },
      expression: "asset_main_information.server_port"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "资源类型",
      "prop": "server_virtualization_type"
    }
  }, [_c('sys_code_select', {
    attrs: {
      "sys_code_has_all": false,
      "sys_code_type": "server_virtualization_type",
      "default_value": _vm.asset_main_information.server_virtualization_type
    },
    model: {
      value: (_vm.asset_main_information.server_virtualization_type),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "server_virtualization_type", $$v)
      },
      expression: "asset_main_information.server_virtualization_type"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CPU频率",
      "prop": "cpu_frequency"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.asset_main_information.cpu_frequency),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "cpu_frequency", $$v)
      },
      expression: "asset_main_information.cpu_frequency"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CPU核数",
      "prop": "cpu_cores"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.asset_main_information.cpu_cores),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "cpu_cores", $$v)
      },
      expression: "asset_main_information.cpu_cores"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "硬盘总容量GB",
      "prop": "disk_total_size"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.asset_main_information.disk_total_size),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "disk_total_size", $$v)
      },
      expression: "asset_main_information.disk_total_size"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物理内存GB",
      "prop": "memory_size"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.asset_main_information.memory_size),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "memory_size", $$v)
      },
      expression: "asset_main_information.memory_size"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "激活",
      "prop": "is_actived"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.asset_main_information.is_actived),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "is_actived", $$v)
      },
      expression: "asset_main_information.is_actived"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "8px"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "协议",
      "prop": "connect_protocol_type_code"
    }
  }, [_c('sys_code_select', {
    attrs: {
      "sys_code_has_all": false,
      "sys_code_type": "connect_protocol_type",
      "default_value": _vm.asset_main_information.connect_protocol_type_code
    },
    model: {
      value: (_vm.asset_main_information.connect_protocol_type_code),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "connect_protocol_type_code", $$v)
      },
      expression: "asset_main_information.connect_protocol_type_code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公网地址",
      "prop": "internet_address"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.asset_main_information.internet_address),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "internet_address", $$v)
      },
      expression: "asset_main_information.internet_address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CPU颗数",
      "prop": "cpu_physical_count"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.asset_main_information.cpu_physical_count),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "cpu_physical_count", $$v)
      },
      expression: "asset_main_information.cpu_physical_count"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CPU缓存kb",
      "prop": "cpu_cache"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.asset_main_information.cpu_cache),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "cpu_cache", $$v)
      },
      expression: "asset_main_information.cpu_cache"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "磁盘数量",
      "prop": "disk_count"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.asset_main_information.disk_count),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "disk_count", $$v)
      },
      expression: "asset_main_information.disk_count"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "逻辑核",
      "prop": "cpu_logic_count"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.asset_main_information.cpu_logic_count),
      callback: function($$v) {
        _vm.$set(_vm.asset_main_information, "cpu_logic_count", $$v)
      },
      expression: "asset_main_information.cpu_logic_count"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-divider', {
    staticStyle: {
      "margin": "10px 0px",
      "width": "99%"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "asset_other_information",
    attrs: {
      "model": _vm.asset_other_information,
      "label-width": "110px",
      "size": "mini",
      "label-position": _vm.labelPosition
    }
  }, [(_vm.assets_add_edit) ? _c('el-form-item', {
    attrs: {
      "label": "标签",
      "prop": "label_ids"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "99%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    on: {
      "sys_code_change": _vm.label_change
    },
    model: {
      value: (_vm.asset_other_information.label_ids),
      callback: function($$v) {
        _vm.$set(_vm.asset_other_information, "label_ids", $$v)
      },
      expression: "asset_other_information.label_ids"
    }
  }, _vm._l((_vm.laber_data), function(item) {
    return _c('el-option', {
      key: item.label_id,
      attrs: {
        "label": item.label_name,
        "value": item.label_id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "other_comments"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "99%"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.asset_other_information.other_comments),
      callback: function($$v) {
        _vm.$set(_vm.asset_other_information, "other_comments", $$v)
      },
      expression: "asset_other_information.other_comments"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "拓补信息"
    }
  }, [_c('el-form', {
    ref: "asset_topology_information",
    staticClass: "form-body",
    style: (_vm.box_style),
    attrs: {
      "label-width": "120px",
      "size": "mini",
      "label-position": _vm.labelPosition,
      "model": _vm.asset_topology_information
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "区域",
      "rules": {
        required: true,
        message: '区域不能为空',
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.area_path),
      callback: function($$v) {
        _vm.area_path = $$v
      },
      expression: "area_path"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Vmware宿主机",
      "prop": "host_machine_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.vmware_change
    },
    model: {
      value: (_vm.asset_topology_information.host_machine_id),
      callback: function($$v) {
        _vm.$set(_vm.asset_topology_information, "host_machine_id", $$v)
      },
      expression: "asset_topology_information.host_machine_id"
    }
  }, _vm._l((_vm.host_machine_data), function(item) {
    return _c('el-option', {
      key: item.server_id,
      attrs: {
        "label": item.server_ip,
        "value": item.server_id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "margin": "4px 25px",
      "color": "#BCBCBC"
    }
  }, [_vm._v("非vmware虚拟化主机无需填写此项")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "父节点",
      "prop": "father_node"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.asset_topology_information.father_node),
      callback: function($$v) {
        _vm.$set(_vm.asset_topology_information, "father_node", $$v)
      },
      expression: "asset_topology_information.father_node"
    }
  }, _vm._l((_vm.assets_add_data), function(item) {
    return _c('el-option', {
      key: item.server_id,
      attrs: {
        "label": item.server_ip,
        "value": item.server_id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "margin": "4px 25px",
      "color": "#BCBCBC"
    }
  }, [_vm._v("父节点描述其上游的基础设施，比如所属宿主机，网络连接交换机等")]), _c('br')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "子节点",
      "prop": "child_node"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.asset_topology_information.child_node),
      callback: function($$v) {
        _vm.$set(_vm.asset_topology_information, "child_node", $$v)
      },
      expression: "asset_topology_information.child_node"
    }
  }, _vm._l((_vm.assets_add_data), function(item) {
    return _c('el-option', {
      key: item.server_id,
      attrs: {
        "label": item.server_ip,
        "value": item.server_id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "margin": "4px 25px",
      "color": "#BCBCBC"
    }
  }, [_vm._v("子节点描述其下游基础设置，与父节点对应")]), _c('br')], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [(_vm.seach_or_edit) ? _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handle_close
    }
  }, [_vm._v("关 闭")]) : _vm._e(), _vm._v(" "), (_vm.seach_or_edit) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.asset_addall_button('asset_main_information_batch')
      }
    }
  }, [_vm._v("确 定")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "asset_user_from",
    attrs: {
      "append-to-body": "",
      "title": _vm.asset_user_title,
      "visible": _vm.dialogAdd_user,
      "close-on-click-modal": false,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogAdd_user = $event
      }
    }
  }, [_c('el-form', {
    ref: "asset_user_from",
    staticStyle: {
      "padding": "8px"
    },
    attrs: {
      "label-width": "100px",
      "size": "mini",
      "status-icon": "",
      "model": _vm.asset_user_from,
      "rules": _vm.rules,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "user_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "95%"
    },
    model: {
      value: (_vm.asset_user_from.user_name),
      callback: function($$v) {
        _vm.$set(_vm.asset_user_from, "user_name", $$v)
      },
      expression: "asset_user_from.user_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户类型",
      "prop": "ossoft_user_group_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "default_value": _vm.asset_user_from.ossoft_user_group_id,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.asset_user_from.ossoft_user_group_id),
      callback: function($$v) {
        _vm.$set(_vm.asset_user_from, "ossoft_user_group_id", $$v)
      },
      expression: "asset_user_from.ossoft_user_group_id"
    }
  }, _vm._l((_vm.ossoft_user_options), function(item) {
    return _c('el-option', {
      key: item.ossoft_user_group_id,
      attrs: {
        "label": item.user_group_name,
        "value": item.ossoft_user_group_id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户主目录",
      "prop": "user_home"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "98%"
    },
    model: {
      value: (_vm.asset_user_from.user_home),
      callback: function($$v) {
        _vm.$set(_vm.asset_user_from, "user_home", $$v)
      },
      expression: "asset_user_from.user_home"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "默认用户",
      "prop": "default_user"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.asset_user_from.default_user),
      callback: function($$v) {
        _vm.$set(_vm.asset_user_from, "default_user", $$v)
      },
      expression: "asset_user_from.default_user"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "margin": "4px 25px",
      "color": "#BCBCBC"
    }
  }, [_vm._v("默认用户在一些未指定用户登录的场景下使用此用户登录")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "comments"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "98%"
    },
    model: {
      value: (_vm.asset_user_from.comments),
      callback: function($$v) {
        _vm.$set(_vm.asset_user_from, "comments", $$v)
      },
      expression: "asset_user_from.comments"
    }
  })], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "user_pwd"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.asset_user_from.user_pwd),
      callback: function($$v) {
        _vm.$set(_vm.asset_user_from, "user_pwd", $$v)
      },
      expression: "asset_user_from.user_pwd"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "重复密码",
      "prop": "user_pwd2"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.asset_user_from.user_pwd2),
      callback: function($$v) {
        _vm.$set(_vm.asset_user_from, "user_pwd2", $$v)
      },
      expression: "asset_user_from.user_pwd2"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogAdd_user = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('asset_user_from')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "append-to-body": "",
      "title": _vm.asset_user_title,
      "visible": _vm.dialogedit_user,
      "close-on-click-modal": false,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogedit_user = $event
      }
    }
  }, [_c('el-form', {
    ref: "asset_user_from",
    staticStyle: {
      "padding": "8px"
    },
    attrs: {
      "label-width": "100px",
      "size": "mini",
      "status-icon": "",
      "model": _vm.asset_user_from,
      "rules": _vm.rules_edit,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "user_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    model: {
      value: (_vm.asset_user_from.user_name),
      callback: function($$v) {
        _vm.$set(_vm.asset_user_from, "user_name", $$v)
      },
      expression: "asset_user_from.user_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户类型",
      "prop": "ossoft_user_group_id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.asset_user_from.ossoft_user_group_id),
      callback: function($$v) {
        _vm.$set(_vm.asset_user_from, "ossoft_user_group_id", $$v)
      },
      expression: "asset_user_from.ossoft_user_group_id"
    }
  }, _vm._l((_vm.ossoft_user_options), function(item) {
    return _c('el-option', {
      key: item.ossoft_user_group_id,
      attrs: {
        "label": item.user_group_name,
        "value": item.ossoft_user_group_id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户主目录",
      "prop": "user_home"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "45%"
    },
    model: {
      value: (_vm.asset_user_from.user_home),
      callback: function($$v) {
        _vm.$set(_vm.asset_user_from, "user_home", $$v)
      },
      expression: "asset_user_from.user_home"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "默认用户",
      "prop": "default_user"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.asset_user_from.default_user),
      callback: function($$v) {
        _vm.$set(_vm.asset_user_from, "default_user", $$v)
      },
      expression: "asset_user_from.default_user"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "margin": "4px 25px",
      "color": "#BCBCBC"
    }
  }, [_vm._v("默认用户在一些未指定用户登录的场景下使用此用户登录")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "comments"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "95%"
    },
    model: {
      value: (_vm.asset_user_from.comments),
      callback: function($$v) {
        _vm.$set(_vm.asset_user_from, "comments", $$v)
      },
      expression: "asset_user_from.comments"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('asset_user_from')
      }
    }
  }, [_vm._v("确 定\n        ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogedit_user = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "append-to-body": "",
      "title": "修改密码",
      "visible": _vm.edit_user_password,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.edit_user_password = $event
      }
    }
  }, [_c('el-form', {
    ref: "user_password_form",
    staticStyle: {
      "padding": "8px"
    },
    attrs: {
      "label-width": "100px",
      "size": "mini",
      "status-icon": "",
      "model": _vm.user_password_form,
      "rules": _vm.rules_password,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "user_pwd"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "type": "password",
      "show-password": ""
    },
    model: {
      value: (_vm.user_password_form.user_pwd),
      callback: function($$v) {
        _vm.$set(_vm.user_password_form, "user_pwd", $$v)
      },
      expression: "user_password_form.user_pwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认",
      "prop": "user_pwd2"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "type": "password",
      "show-password": ""
    },
    model: {
      value: (_vm.user_password_form.user_pwd2),
      callback: function($$v) {
        _vm.$set(_vm.user_password_form, "user_pwd2", $$v)
      },
      expression: "user_password_form.user_pwd2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading_update_password),
      expression: "loading_update_password"
    }],
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.update_password()
      }
    }
  }, [_vm._v("确 定\n        ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.edit_user_password = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-7e2f63ef","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common_page/assert_manage.vue
// module id = HscO
// module chunks = 81